/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import type ItemMetadata from 'pages/open-course/common/models/itemMetadata';

import { Typography, breakpoints } from '@coursera/cds-core';

import EmbeddedSourceCourseAttribution from 'bundles/common/components/EmbeddedSourceCourseAttribution';
import { EmbeddedSourceCourseNameOptions } from 'bundles/common/lms-authoring/types/EmbeddedSourceCourseNameOptions';
import TranslatedContentTag from 'bundles/course-notifications-v2/components/translatedContent/TranslatedContentTag';

type Props = {
  itemName?: string | JSX.Element;
  itemMetadata?: ItemMetadata;
  courseId?: string;
  contentBeforeName?: React.ReactElement;
};

const styles = {
  title: () => css`
    margin-bottom: var(--cds-spacing-400);
    ${breakpoints.up('md')} {
      margin-bottom: var(--cds-spacing-600);
    }
  `,
  embeddedContentAttribution: () => css`
    margin-top: var(--cds-spacing-200);
  `,
};

const ItemTitle: React.FC<Props> = ({ itemName, contentBeforeName, itemMetadata, courseId }) => {
  return (
    <div css={styles.title}>
      <Typography variant="d2" component="h1">
        {contentBeforeName}
        {itemName}
        {courseId && <TranslatedContentTag courseId={courseId} />}
      </Typography>
      {itemMetadata?.getEmbeddedContentSourceCourseId() && (
        <div css={styles.embeddedContentAttribution} data-testid="embedded-attribution-info">
          <EmbeddedSourceCourseAttribution
            embeddedContentSourceCourseId={itemMetadata.getEmbeddedContentSourceCourseId()}
            includeCourseName={EmbeddedSourceCourseNameOptions.INLINE}
            originalName={itemMetadata.getOriginalName()}
          />
        </div>
      )}
    </div>
  );
};

export default ItemTitle;
